<template>
  <v-snackbar
    v-model="show"
    :timeout="0"
    top
  >
    <span class="caption">
      Your current browser, {{ currentBrowserName }}, may not be supported.
      <br>
      Please use
      <a
        href="https://www.mozilla.org/firefox/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Firefox
      </a>
      or
      <a
        href="https://www.google.com/chrome/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Chrome
      </a>
      for the best experience.
    </span>
    <v-btn
      color="primary"
      text
      @click="show = false"
    >
      Dismiss
    </v-btn>
  </v-snackbar>
</template>

<script>
import UAParser from 'ua-parser-js';

export default {
  name: 'BrowserWarning',

  data() {
    return {
      show: false,
      currentBrowserName: null,
      unsupportedBrowsers: [
        'IE',
        'Safari',
      ],
    };
  },

  created() {
    this.currentBrowserName = (new UAParser()).getBrowser().name;

    if (this.unsupportedBrowsers.includes(this.currentBrowserName)) {
      this.show = true;
    }
  },
};
</script>
